import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, TmsWebBaseService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class ProductLogoService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('ProductLogo', httpService);
  }

  uploadImage(productId: string, fileName: string, file: any, image2: boolean): Observable<any> {
    return this.httpService.postForText(`${this.apiUrl}/${productId}/${fileName}/${image2}`, file);
  }

  removeImage(productId: string, image2: boolean): Observable<any> {
    return this.httpService.delete(`${this.apiUrl}/${productId}/${image2}`);
  }
}
